module.exports = __webpack_public_path__ + "static/media/project_placeholder.362224ce.jpg";